export default {
  "content": "<path d=\"M7.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 3a1 1 0 01.948.684L4.721 6H22a1.001 1.001 0 01.958 1.287l-3 10A1 1 0 0119 18H7a1 1 0 01-.958-.713l-3-10L2.279 5H.5V3H3zm4.744 13h10.512l2.4-8H5.344l2.4 8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};